<template>
  <div
    :class="bannerClassList"
    :style="{
      bottom: fixedBottomValue ? fixedBottomValue : 'initial',
      maxWidth: '800px',
    }"
    data-qa="club_detail_info_banner"
  >
    <div
      class="club-detail-info-banner__content"
      :class="{
        'd-flex align-center justify-space-between': !isMobile,
      }"
    >
      <div class="text--text">
        <div
          class="text-subtitle-1"
          data-qa="club_detail_info_banner_title"
        >
          {{ title }}
        </div>
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="subtitle"
          class="text-body-2 mt-1"
          data-qa="club_detail_info_banner_subtitle"
          v-html="subtitle"
        />
        <!-- eslint-enable vue/no-v-html -->
      </div>
      <v-btn
        v-if="textButton"
        class="club-detail-info-banner__button"
        data-qa="club_detail_info_banner_button"
        :class="isMobile ? 'mt-3' : 'ml-3'"
        :small="isMobile"
        depressed
        @click="emitClickButton"
      >
        <span class="bg-gray-0--text">
          {{ textButton }}
        </span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { CLUB_EVENTS } from 'www/constants'
import { dispatchCustomEventGlobally } from 'www/utils'

export default {
  name: 'ClubDetailInfoBanner',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    textButton: {
      type: String,
      default: '',
    },
    fixedBottomValue: {
      type: String,
      default: '8px',
    },
    hide: {
      type: Boolean,
      default: false,
    },
    useGlobalDispatch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isEnabled: !this.hide,
      isMobile: window.MOBILE_VERSION,
    }
  },
  computed: {
    bannerClassList() {
      const arr = ['club-detail-info-banner', 'mx-auto']

      if (this.isEnabled) {
        arr.push('club-detail-info-banner_enabled')
      } else {
        arr.push('club-detail-info-banner_disabled')
      }

      if (this.fixedBottomValue) {
        arr.push('club-detail-info-banner_fixed-bottom')
      }

      return arr
    },
  },
  watch: {
    hide(hidden) {
      this.isEnabled = !hidden
    },
  },
  mounted() {
    if (this.useGlobalDispatch) {
      window.addEventListener('club-detail-info-banner:change-state', this.handleClubDetailInfoBannerChangeState)
    }
  },
  methods: {
    handleClubDetailInfoBannerChangeState({ detail }) {
      this.isEnabled = detail.isEnabled
    },
    emitClickButton() {
      this.$emit(CLUB_EVENTS.detailInfoBannerClick)

      dispatchCustomEventGlobally(CLUB_EVENTS.detailInfoBannerClick, {
        appointmentData: {},
        isRedirectViaBanner: true,
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import '~www/themes/doctors/common/variables';

.club-detail-info-banner {
  padding: 1px;
  transition: all 0.2s ease-out;
  border-radius: $border-radius-md;
  background-image: $club-coral-linear-gradient;

  &__content {
    border-radius: inherit;
    padding: 16px;
    background-color: $ui-kit-bg-club;
  }

  &__button {
    background-image: $club-coral-linear-gradient;
  }

  &_fixed-bottom {
    z-index: 5;
    left: 8px;
    right: 8px;
    position: fixed;
  }

  &_disabled {
    opacity: 0;
    user-select: none;
    pointer-events: none;
  }

  &_enabled {
    opacity: 1;
    user-select: initial;
    pointer-events: initial;
  }
}
</style>
